(function() {
    'use strict';

    angular.module('GorillaBoy.services')
    .factory('GroupCollectionService', ['$http', 'EndpointService', 'AppConstants',
        function($http, EndpointService, AppConstants) {

            // AppConstant bindings
            var httpMethods = AppConstants.HttpMethods;

            var groupCollectionService = {},
                SERVICE_ROOT = function () {
                    return EndpointService.endpoint() + 'collection/group';
                };
    
            groupCollectionService.searchGroupCollection = function(params, cancelerPromise) {
                var defaultParams = {
                    vendor: 'DIRECTORY_SERVICE'
                };

                params = angular.extend({}, defaultParams, params);

                var config = {
                    url: SERVICE_ROOT(),
                    method: httpMethods.GET,
                    params: params
                };

                if (cancelerPromise) {
                    config.timeout = cancelerPromise;
                }

                return $http(EndpointService.tokenize(config));
            };

            return groupCollectionService;
        }]);
}());
